const iconfont2 = process.server ? null : require("./iconfont").default;

export default iconfont2;
